<template>
  <img :src="computedSrc" :alt="alt"/>
</template>
<script>
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default {
  name: 'm-img',
  props: {
    src: {
      type: String,
      default: 'https://picsum.photos/1280/720'
    },
    alt: {
      type: String,
      default: 'mix it web'
    }
  },
  computed: {
    computedSrc() {
      return this.src ? this.src : findAttributeOnSiteInfo("default_product_image");
    }
  }
}
</script>